
import React from "react";

import { ImageCustom } from '../Image';
import {
  PillarsCards,
  TitlePillar,
  SubTitlePillar,
  PillarsImgs,
  TextImgs,
  IconsCards,
} from './style';

type PillarsWrapperProps = {
  icon: string;
  title: string;
  subtitle: string;
};

const PillarsWrapper = ({ icon, title, subtitle }: PillarsWrapperProps) => {

  return (
    <PillarsCards>
      <PillarsImgs>
        <IconsCards>
          <ImageCustom src={icon} alt="" />
        </IconsCards>
      </PillarsImgs>
      <TitlePillar>
        {title}
      </TitlePillar>
      <SubTitlePillar>
        {subtitle}
      </SubTitlePillar>
    </PillarsCards>
  );
}

export default PillarsWrapper;


